import { render, staticRenderFns } from "./EditAudioCodecsForm.vue?vue&type=template&id=30925f20&scoped=true&"
import script from "./EditAudioCodecsForm.vue?vue&type=script&lang=js&"
export * from "./EditAudioCodecsForm.vue?vue&type=script&lang=js&"
import style0 from "./EditAudioCodecsForm.vue?vue&type=style&index=0&id=30925f20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30925f20",
  null
  
)

export default component.exports